import React from 'react';
import { ProviderMatchProviderV9 } from '@kyruus/types';
import { FormattedMessage } from '@kyruus/intl';

import ExpandableCardContainer from '../ExpandableCardContainer/expandable-card-container';
import { TrackingFunction } from '../../lib/tracking-utils';
import messages from '../../lib/messages';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import { ClinicalInterestsTitle, ClinicalInterestsContentText } from './styles';

interface ProviderClinicalInterestsProps {
  provider: ProviderMatchProviderV9;
  track: TrackingFunction;
}

/**
 * Renders the Provider Clinical Interests component.
 *
 * @param {ProviderClinicalInterestsProps} props - The component props.
 * @returns {React.ReactElement} The rendered Provider Clinical Interests component.
 */
const ProviderClinicalInterests = ({
  provider,
  track
}: ProviderClinicalInterestsProps): React.ReactElement | null => {
  // do not render if data not present
  if (
    !provider.clinical_interests ||
    provider.clinical_interests.length === 0
  ) {
    return null;
  }
  return (
    <ExpandableCardContainer
      id="profile-clinical-interests-section"
      track={track}
    >
      <ClinicalInterestsTitle>
        <FormattedMessage {...messages.providerClinicalInterestsTitle} />
      </ClinicalInterestsTitle>
      {/* child components will not render if data does not exist or is empty */}
      <ClinicalInterestsContentText
        content={provider.clinical_interests ?? ''}
        data-testid={'clinical-interests-content'}
        disableDefaultMatchers={true}
        itemProp="description"
      />
    </ExpandableCardContainer>
  );
};

export default withErrorBoundary(ProviderClinicalInterests);
